import apiHandler from "../core/apiHandler";

const consumerFinalSaleApi = apiHandler('consumer-final-sales');
export default consumerFinalSaleApi;
